import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "calendar-cards-tooltip" }

import CalendarCardItem from '../CalendarCardItem.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarCardsTooltip',
  props: {
  cardList: {
    type: Array,
    required: true,
  },
  weekId: {
    type: Number,
    required: true,
  },
  maxCardsVisible: {
    type: Number,
    required: true,
  },
},
  emits: ['close-tippy'],
  setup(__props, { emit: __emit }) {



const emit = __emit;

const openCard = () => {
  emit('close-tippy');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.cardList, (card, index) => {
      return (_openBlock(), _createBlock(CalendarCardItem, {
        key: index,
        card: card,
        "week-id": __props.weekId,
        index: index,
        "max-cards-visible": __props.maxCardsVisible,
        "in-tooltip": true,
        onOpenCard: openCard
      }, null, 8, ["card", "week-id", "index", "max-cards-visible"]))
    }), 128))
  ]))
}
}

})